module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigator"
  }, [_c('h2', {
    staticClass: "mr-auto"
  }, [_vm._v(_vm._s(_vm.navigatorTitle))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-4893bcac", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4893bcac"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/people/agents/AgentNavigator.vue
// module id = 812
// module chunks = 0